module.exports = __webpack_public_path__ + "img/ca.ed3cd4b5.svg";